export const GET_CONTRACTS_REQUEST = 'GET_CONTRACTS_REQUEST';
export const GET_CONTRACTS_SUCCESS = 'GET_CONTRACTS_SUCCESS';
export const GET_CONTRACTS_FAILURE = 'GET_CONTRACTS_FAILURE';

export const GET_CONTRACT_REQUEST = 'GET_CONTRACT_REQUEST';
export const GET_CONTRACT_SUCCESS = 'GET_CONTRACT_SUCCESS';
export const GET_CONTRACT_FAILURE = 'GET_CONTRACT_FAILURE';

export const UPDATE_CONTRACT_REQUEST = 'UPDATE_CONTRACT_REQUEST';
export const UPDATE_CONTRACT_SUCCESS = 'UPDATE_CONTRACT_SUCCESS';
export const UPDATE_CONTRACT_FAILURE = 'UPDATE_CONTRACT_FAILURE';

export const CONFIRM_CONTRACT_REQUEST = 'CONFIRM_CONTRACT_REQUEST';
export const CONFIRM_CONTRACT_SUCCESS = 'CONFIRM_CONTRACT_SUCCESS';
export const CONFIRM_CONTRACT_FAILURE = 'CONFIRM_CONTRACT_FAILURE';

export const CHANGE_CONTRACT_REQUEST = 'CHANGE_CONTRACT_REQUEST';
export const CHANGE_CONTRACT_SUCCESS = 'CHANGE_CONTRACT_SUCCESS';
export const CHANGE_CONTRACT_FAILURE = 'CHANGE_CONTRACT_FAILURE';

export const ACCEPT_CHANGE_CONTRACT_REQUEST = 'ACCEPT_CHANGE_CONTRACT_REQUEST';
export const ACCEPT_CHANGE_CONTRACT_SUCCESS = 'ACCEPT_CHANGE_CONTRACT_SUCCESS';
export const ACCEPT_CHANGE_CONTRACT_FAILURE = 'ACCEPT_CHANGE_CONTRACT_FAILURE';

export const DELETE_CONTRACT_REQUEST = 'DELETE_CONTRACT_REQUEST';
export const DELETE_CONTRACT_SUCCESS = 'DELETE_CONTRACT_SUCCESS';
export const DELETE_CONTRACT_FAILURE = 'DELETE_CONTRACT_FAILURE';

export const COPY_CONTRACT_REQUEST = 'COPY_CONTRACT_REQUEST';
export const COPY_CONTRACT_SUCCESS = 'COPY_CONTRACT_SUCCESS';
export const COPY_CONTRACT_FAILURE = 'COPY_CONTRACT_FAILURE';

export const STOP_CONTRACT_REQUEST = 'STOP_CONTRACT_REQUEST';
export const STOP_CONTRACT_SUCCESS = 'STOP_CONTRACT_SUCCESS';
export const STOP_CONTRACT_FAILURE = 'STOP_CONTRACT_FAILURE';

export const SET_SCHOOL_COMMENT_REQUEST = 'SET_SCHOOL_COMMENT_REQUEST';
export const SET_SCHOOL_COMMENT_SUCCESS = 'SET_SCHOOL_COMMENT_SUCCESS';
export const SET_SCHOOL_COMMENT_FAILURE = 'SET_SCHOOL_COMMENT_FAILURE';

export const SET_SCHOOL_YEAR_REQUEST = 'SET_SCHOOL_YEAR_REQUEST';
export const SET_SCHOOL_YEAR_SUCCESS = 'SET_SCHOOL_YEAR_SUCCESS';
export const SET_SCHOOL_YEAR_FAILURE = 'SET_SCHOOL_YEAR_FAILURE';

export const RESET_CONTRACTS_LOADED = 'RESET_CONTRACTS_LOADED';

export const ADD_CONTRACT_REQUEST = 'ADD_CONTRACT_REQUEST';
export const ADD_CONTRACT_SUCCESS = 'ADD_CONTRACT_SUCCESS';
export const ADD_CONTRACT_FAILURE = 'ADD_CONTRACT_FAILURE';
